import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatError, MatFormField, MatInput } from '@angular/material/input';
import { Project } from '../../../../../models/project.module';
import { ToastNotificationService } from '../../../../../services/toast-notification.service';
import { ErrorStructure } from '../../../../../models/general.models';
import { User } from '../../../../../models/user.model';
import { Selectedlayer } from '../../../../../models/layer.models';
import { BookmarkService } from '../../../../../services/bookmark.service';
import { HttpErrorResponse } from '@angular/common/http';
import { findFirstNonEmptyString } from '../../../../../utils';
import { Bookmark } from '../../../../../models/bookmark.model';

@Component({
  selector: 'frmg-create-bookmark',
  templateUrl: './create-bookmark-modal.component.html',
  styleUrls: ['./create-bookmark-modal.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatError,
    MatButton,
    MatDialogClose
  ]
})
export class CreateBookmarkModalComponent implements OnInit {
  public bookmarkFg: FormGroup;
  public currentUser: User;
  public isLoading = false;
  public errors: ErrorStructure[] = [];
  // eslint-disable-next-line no-control-regex
  private forbiddenPattern = /^[^<>:"/\\|?*\x00]*$/;

  @ViewChild('autosize') autosize: CdkTextareaAutosize;

  constructor(
    private dialogRef: MatDialogRef<CreateBookmarkModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { folder: Project; project?: Project, layers: Selectedlayer[], bbox: number[], bookmark: Bookmark },
    private fb: FormBuilder,
    private bookmarkService: BookmarkService,
    private toastNotificationService: ToastNotificationService
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('user')) as User;
    this.bookmarkFg = this.fb.group({
      name: [this.data.bookmark?.name || this.data.project?.name || '', [Validators.required, Validators.maxLength(255), Validators.pattern(this.forbiddenPattern)]]
    });
    this.bookmarkFg.valueChanges.subscribe(_ => {
      this.bookmarkFg.clearValidators();
      this.errors = [];
    });
  }

  ngOnInit(): void {
  }

  public closeDialog(result?: any): void {
    this.dialogRef.close(result);
  }

  public addBookmark(): void {
    this.errors = [];
    this.isLoading = true;
    if (this.data.bookmark) {
      this.bookmarkService.updateBookmark({ name: this.bookmarkFg.value.name }, this.data.bookmark.project_id,  this.data.bookmark.id).subscribe(resp => {
        this.toastNotificationService.showNotification({ message: 'Bookmark updated Successfully', type: 'success' });
        this.dialogRef.close(resp);
      }, (error: HttpErrorResponse) => {
        const errorMsg = 'An error occurred while updating bookmark.';
        switch (error.status) {
          case 422:
            this.errors = error.error.detail;
            break;
          default:
        }
        this.toastNotificationService.showNotification({ message: errorMsg, type: 'error' });
      });
    } else {
      const groupValue = this.bookmarkFg.value;

      const projectData: Partial<Bookmark> = {
        name: groupValue.name,
        folder_id: this.data.project?.id,
        visible_layers: this.data.layers.filter(layer => layer.active).map(layer => layer.layer.layer.name),
        bbox: this.data.bbox,
        bookmark_metadata: {
          created_by: this.currentUser.email,
          created_at: new Date().toISOString(),
          folder_name: this.data.project.name,
          layers_data: this.data.layers,
          folder: this.data.project
        }
      };
      this.bookmarkService.createBookmark(projectData, this.data.project?.project_id).subscribe(resp => {
        this.toastNotificationService.showNotification({ message: 'Bookmark created Successfully', type: 'success' });
        this.dialogRef.close(resp);
      }, (error: HttpErrorResponse) => {
        const errorMsg = 'An error occurred while creating the project.';
        switch (error.status) {
          case 422:
            this.errors = error.error.detail;
            break;
          default:
            this.toastNotificationService.showNotification({
              type: 'error',
              message: findFirstNonEmptyString(error.error.detail) || errorMsg
            });
        }
        this.isLoading = false;
      });
    }
  }

  public fieldError(key: string) {
    if (this.errors.length) {
      const error = this.errors.find(error => error.loc.includes(key));
      if (error) {
        this.bookmarkFg.get(key).setErrors({ incorrect: true });
        return error.msg;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }
}
